<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
{{ data.message }}
</mat-dialog-content>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-flat-button cdkFocusInitial color="primary" [mat-dialog-close]="true">
    {{ 'common.ok' | translate }}
  </button>
</div>
